import React from 'react';

import {$} from '../lib/ext-refs';
import BootstrapDialog from '../lib/bootstrap-dialog';

// Simple Bootstrap modal scaffolding
// handleClose - when modal is called
class CancelDialog extends BootstrapDialog {
    constructor(props) {
        super(props);
        this.handleAcceptClick = this.handleAcceptClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleAcceptClick() {
        this.closeDialog();
        this.props.handleAccept();
    }

    handleClose() {
        this.props.handleClose();
    }

    render() {
        const {messages} = this.props.config;
        return (
            <BootstrapDialog
                className="modal mdb-modal fade"
                aria-labelledby="modal-cancel-payment-title"
                aria-hidden="true"
                handleClose={this.handleClose}
            >
                <div className="modal-dialog modal-notify modal-danger" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modal-cancel-payment-title">
                                {messages["opp.cancelPaymentModal.title"]}
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                <span aria-hidden="true" className="white-text">
                  <i className="material-icons">{messages["icon.material.close.label"]}</i>
                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12">
                                    <p>
                                        <strong>{messages["opp.cancelPaymentModal.msg1"]}</strong>
                                    </p>
                                    <p>
                                        <strong>{messages["opp.cancelPaymentModal.msg2"]}</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer align-button-between-left">
                            <button
                                type="button"
                                className="btn btn-outline-danger btn-modal-cancel"
                                data-dismiss="modal"
                            >
                                {messages["do.not.cancel.payment.button.label"]}
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger waves-effect btn-modal-confirm"
                                data-dismiss="modal"
                                onClick={this.handleAcceptClick}
                            >
                                {messages["opp.cancel.payment.button.label"]}
                            </button>
                        </div>
                    </div>
                </div>
            </BootstrapDialog>
        );
    }
}

export default CancelDialog;